/* eslint-disable max-len */

import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import SectionHeader from '../../../../atoms/SectionHeader';
import { matchImageWithBreakpoint } from './helpers';

export const BeforeAfterSection = ({
  sectionHeadings,
  images,
  currentBreakpoint,
}) => {
  const beforeImage = matchImageWithBreakpoint({
    currentBreakpoint,
    image: R.prop('before', images),
  });

  const afterImage = matchImageWithBreakpoint({
    currentBreakpoint,
    image: R.prop('after', images),
  });

  const slideButtonImage = matchImageWithBreakpoint({
    currentBreakpoint,
    image: R.prop('slideButton', images),
  });

  if (!beforeImage || !afterImage) {
    return null;
  }

  return (
    <div className="before-after-section">
      <div className="grid-container">
        <div className="grid-x grid-margin-x flex-container align-middle align-center">
          <div className="cell">
            <SectionHeader>
              <Heading extraClass="section__title" level={2}>
                {R.path(['beforeAfter', 'heading'])(sectionHeadings)}
              </Heading>

              <Paragraph>
                {R.path(['beforeAfter', 'introduction'], sectionHeadings)}
              </Paragraph>
            </SectionHeader>
          </div>

          <div className="before-after-section__slider">
            <ImgComparisonSlider>
              <img
                slot="first"
                src={beforeImage}
                alt={R.path(['before', 'alt'], images)}
              />

              <img
                slot="second"
                src={afterImage}
                alt={R.path(['after', 'alt'], images)}
              />

              <div className="handle" slot="handle">
                <img
                  src={slideButtonImage}
                  alt={R.path(['slideButton', 'alt'], images)}
                />
              </div>
            </ImgComparisonSlider>

            <img
              className="before-after-section__bottle"
              alt=""
              src="/ccx-files/assets/bottle.png"
            />

            <Paragraph extraClass="before-after-section__slider-text">
              {R.path(['beforeAfter', 'subheading'])(sectionHeadings)}
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
};

BeforeAfterSection.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  images: PropTypes.instanceOf(PropTypes.object),
  currentBreakpoint: PropTypes.instanceOf(PropTypes.object),
};
